var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { isAxiosError } from 'axios';
const ORDER_LINE_STATUSES = (orderId) => `/api/v2/order/${orderId}/line-statuses`;
export const updateLineAssignments = function (orderId, dto) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        try {
            return yield this.axiosInstance.patch(`/api/v2/order/${orderId}/line-assignments`, dto, {
                headers: { Authorization: `Bearer ${this.apiToken}` },
            });
        }
        catch (error) {
            console.error('Washday SDK - Error updating order line assignments:', {
                status: isAxiosError(error) ? (_a = error.response) === null || _a === void 0 ? void 0 : _a.status : undefined,
            });
            throw error;
        }
    });
};
/**
 * Batch update of line-level statuses for a single order.
 *
 * - Validates all transitions server-side before applying any.
 * - Does NOT modify the order's own status.
 * - Returns the full updated order.
 *
 * Actor: Staff / POS (requires valid auth token)
 * Endpoint: PATCH /api/v2/order/:id/line-statuses
 */
export const updateLineStatuses = function (orderId, dto) {
    return __awaiter(this, void 0, void 0, function* () {
        const config = {
            headers: { Authorization: `Bearer ${this.apiToken}` },
        };
        return yield this.axiosInstance.patch(ORDER_LINE_STATUSES(orderId), dto, config);
    });
};
